import { render, staticRenderFns } from "./IdentificationLogCustomer.vue?vue&type=template&id=55c33f46&scoped=true&"
import script from "./IdentificationLogCustomer.vue?vue&type=script&lang=js&"
export * from "./IdentificationLogCustomer.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationLogCustomer.vue?vue&type=style&index=0&id=55c33f46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c33f46",
  null
  
)

export default component.exports